module.exports = __webpack_public_path__ + "static/media/web-img.19a960f9.png";